import { ArrowUpRight, Mail, Phone, Linkedin } from 'lucide-react';
import { NAV_LINKS, CONTACT, BRAND } from '../../lib/site-data';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-ink-900 border-t border-white/10">
      <div className="container-editorial py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <a href="#top" className="inline-flex items-center gap-4 group">
              <span className="inline-flex items-center justify-center bg-white rounded-[6px] p-3 shadow-[0_0_0_1px_rgba(255,255,255,0.12)] transition-transform duration-500 group-hover:-translate-y-0.5">
                <img
                  src={BRAND.logoUrl}
                  alt="George & Milton logo"
                  className="h-16 w-auto"
                  loading="lazy"
                />
              </span>
              <span className="display-heading text-xl tracking-tight text-white sr-only">
                George &amp; Milton
              </span>
            </a>
            <p className="mt-8 max-w-md text-white/60 text-base leading-relaxed">
              A global HR, People Practices, and Culture advisory building organizations designed
              for long-term success.
            </p>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="btn-pill btn-outline mt-8 inline-flex"
            >
              Start a conversation
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Navigate</p>
            <ul className="mt-6 flex flex-col gap-3">
              {NAV_LINKS.map((l, i) => (
                <li key={l.id}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.id}`}
                    className="group inline-flex items-center gap-3 text-white/75 hover:text-white transition-colors duration-300"
                  >
                    <span className="font-mono text-[10px] text-white/35">0{i + 1}</span>
                    <span>{l.label}</span>
                    <ArrowUpRight className="h-3 w-3 text-white/25 group-hover:text-signal-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Contact</p>
            <ul className="mt-6 flex flex-col gap-4">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-signal-500" />
                <a href={`mailto:${CONTACT.email}`} className="text-white/85 hover:text-white transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-signal-500" />
                <a href={`tel:${CONTACT.phone}`} className="text-white/85 hover:text-white transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin className="h-4 w-4 text-signal-500" />
                <a
                  href={CONTACT.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/85 hover:text-white transition-colors"
                >
                  {CONTACT.linkedinLabel}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-16" />

        <div className="mt-8 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-white/45 text-xs">
          <p>© {year} George &amp; Milton. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.25em]">Bengaluru · Delhi · Singapore · London</p>
        </div>
      </div>
    </footer>
  );
}
